import React, { Component, ErrorInfo, ReactNode } from "react";
import { Result } from "antd";
import CustomButton from "./CustomButton";

interface Props {
  children?: ReactNode;
}

interface State {
  hasError: boolean;
  error?: Error;
}

class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
  };

  public static getDerivedStateFromError(error: Error): State {
    // Update state so the next render will show the fallback UI.
    return { hasError: true, error };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error("Uncaught error:", error, errorInfo);
  }

  public render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: "50px", display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
          <Result
            status="error"
            title="出錯了"
            subTitle="發生了未知錯誤，請稍後再試。"
            extra={
              <div style={{ display: "flex", justifyContent: "center", gap: "16px" }}>
                <CustomButton key="console" width={120} height={35} bgColor="#00C7B6" color="#fff" onClick={() => window.location.reload()}>
                  刷新頁面
                </CustomButton>
                <CustomButton key="back" width={120} height={35} bgColor="#fff" color="#666" style={{ border: "1px solid #d9d9d9" }} onClick={() => window.history.back()}>
                  返回上一頁
                </CustomButton>
              </div>  
            }
          >
            {process.env.NODE_ENV === "development" && (
              <div style={{ marginTop: 20, textAlign: "left", background: "#f5f5f5", padding: 10, borderRadius: 4 }}>
                <p style={{ color: "red" }}>{this.state.error?.toString()}</p>
              </div>
            )}
          </Result>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
